/*
	Features are Sherlock fields used to categorise properties. 
*/

Features = {
	// Find check inputs for the feature details UI
	p_input_element : {}
	,
	// Find hidden element which tracks the active feature details. Holds comma delimited list of FD titles.
	p_tracking_element : {}
	,
	init : function()
	{
		// Set properties.
		Features.p_input_element = jQuery('.property-search .oc-feature'); //jQuery('.property-search .features .features .form-check-input');
		Features.p_tracking_element = jQuery('input[name="features_include"]');
		
		// Setup UI.
		Features.setup_ui();
	}
	,
	setup_ui : function()
	{
		// Set check elements to trigger events on change.
		Features.p_input_element.change(function(){
			
			// Set parent element to reflect checked state via class.
			var parent_element = jQuery(this).closest('.form-check');
			
			if( jQuery(this).is(':checked') )
			{
				parent_element.addClass('checked');
			}
			else
			{
				parent_element.removeClass('checked');
			}
			
			// Reset tracking list upon check element update.
			var options = {};
			Features.p_tracking_element.trigger('sh_property_search_features_update',options);
			
		});
		
		// Set tracking element to react to check elements updates.
		// Tracking element holds comma delimited list of Feature titles.
		Features.p_tracking_element.on('sh_property_search_features_update',function(event,pm_options){
			
			// Empty tracking list.
			jQuery(this).val('');
			
			// Iterate through check elements and add checked values to tracking list. 
			var features = '';
			Features.p_input_element.each(function(pm_index){
				var sep = (features == '') ? '' : ',';
				if( jQuery(this).is(':checked') )
				{
					features += sep + jQuery(this).val();
				}
			});
			
			// Fill tracking list with new value.
			jQuery(this).val(features);
			
		});
	}
}


jQuery(document).ready(function(jQuery){
	
	Features.init();

});